import { showFromFade } from "../../js/Util";

const $faqItem = $(".js-faq-item");

$faqItem.click(function () {
    const $el = $(this);

    if ($el.hasClass("_active")) {
        $faqItem.removeClass("_active");
        $el.removeClass("_active");
        $(".faq-item-answear").slideUp(200);
    } else {
        $faqItem.removeClass("_active");
        $el.addClass("_active");
        $(".faq-item-answear").slideUp(200);
        $el.children(".faq-item-answear").slideDown(200);
    }
});

if ($(".faq-block").length) {
    $(".faq-block")
        .each((index, item) => {
            const start =
                $(document).width() >= 768
                    ? "top bottom-=20%"
                    : "top bottom-=10%";
            showFromFade(item, start);
        });
}